import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
//primereact
import { Chip } from "primereact/chip";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { Skeleton } from "primereact/skeleton";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { BreadCrumb } from "primereact/breadcrumb";
import { confirmDialog } from "primereact/confirmdialog";
//components
import Panel from "../../../components/panel/panel";
import Modal from "../../../components/modal/Modal";
import Select from "../../../components/input/Select";
//modals
import ModalAddLead from "./Modals/ModalAddLead";
import ModalWhatsApp from "./Modals/ModalWhatsApp";
import { ModalBooking } from "./Modals/ModalBooking";
import ModalLeadDetails from "./Modals/ModalLeadDetails";
import ModalCalendarSchedules from "./Modals/ModalCalendarSchedules";
import { ModalCompleteRegister } from "./Modals/ModalCompleteRegister";
//react-beautiful-dnd
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
//assets
import defaultImage from "../../../assets/default.jpg";
//hooks
import usePermission from "../../../hooks/usePermission";
import { useOptionsSelect } from "../../../hooks/useOptionsSelect";
//services
import { getKanban } from "../../../services/Crm/Funnel/getKanban";
import { patchLeadStatus } from "../../../services/Crm/Funnel/patchLeadStatus";
import { getFunnelWithStatus } from "../../../services/Crm/Settings/Funnel/getFunnelWithStatus";
import { deleteLead } from "../../../services/Crm/Leads/deleteLead";
import { getTeamList } from "../../../services/GlobalRoles/getTeamList";
import { getTeam } from "../../../services/GlobalRoles/getTeam";
//utils
import { queryClient } from "../../../utils/queryClient";
//context
import { useAppContext } from "../../../context/AppContext";

const Funnel = () => {
  usePermission("230");
  
  // Função utilitária para truncar email
  const truncateEmail = (email, maxLength = 25) => {
    if (!email) return "";
    return email.length > maxLength 
      ? `${email.substring(0, maxLength)}...` 
      : email;
  };

  const form = useForm();
  const { permissions } = useAppContext();
  const prevFunnelRef = useRef(null);
  const [funnel, setFunnel] = useState([]);
  const [leadId, setLeadId] = useState(null);
  const [visible, setVisible] = useState(false);
  const [idFunnel, setIdFunnel] = useState(null);
  const [editedId, setEditedId] = useState(null);
  const [baseData, setBaseData] = useState(null);
  const [movePayload, setMovePayload] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [visibleLead, setVisibleLead] = useState(false);
  const [visibleComplete, setVisibleComplete] = useState(false);
  const [visibleWhatsApp, setVisibleWhatsApp] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null); // Dados do lead selecionado para WhatsApp
  const [selectedColumn, setSelectedColumn] = useState(null);
  const [visibleBooking, setVisibleBooking] = useState(false);
  const [visibleFilters, setVisibleFilters] = useState(false);
  const [visibleCalendar, setVisibleCalendar] = useState(false);
  const [defaultActiveIndex, setDefaultActiveIndex] = useState(0);
  const [selectedEnterprise, setSelectedEnterprise] = useState(null);
  const [selectedBroker, setSelectedBroker] = useState(null);
  const [funnelsOptions, setFunnelsOptions] = useState([]);
  const [teamsOptions, setTeamsOptions] = useState([]);
  const [brokersOptions, setBrokersOptions] = useState([]);
  const [isLoadingTeams, setIsLoadingTeams] = useState(false);
  const [isLoadingBrokers, setIsLoadingBrokers] = useState(false);
  const [deletingLeadId, setDeletingLeadId] = useState(null);
  const items = [
    {
      template: () => (
        <Link to={"/crm/funnel"} className="p-breadcrumb-link">
          Funil de Vendas
        </Link>
      ),
    },
  ];
  const { enterprise, isLoadingEnterprises } = useOptionsSelect();
  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const { data: funnels, isLoading: isLoadingFunnels } = useQuery({
    queryKey: [`funnels`],
    queryFn: () => getFunnelWithStatus(idFunnel),
    onSuccess(data) {
      if (data) {
        form.setValue("funnel", data.data.id);
        setIdFunnel(data.data.id);
      }
    },
    refetchOnWindowFocus: false,
    enabled: !!permissions?.includes("230"),
  });

  const {
    data: kanban,
    isLoading: isLoadingKanban,
    refetch: refetchKanban,
  } = useQuery(["kanban", idFunnel], () => getKanban(idFunnel), {
    enabled: !!idFunnel,
  });
  // console.log(kanban);

  const { mutateAsync: moveLeadAsync } = useMutation(
    (payload) => patchLeadStatus(payload),
    {
      onSuccess: (_res, payload) => {
        queryClient.setQueryData(["kanban", payload.funnel_id], (old) => {
          if (!old) return old;
          const newStatus = old.status.map((col) => ({
            ...col,
            leads: [...col.leads],
          }));
          const sourceCol = newStatus.find((col) =>
            col.leads.some((l) => l.id === payload.lead_id)
          );
          if (!sourceCol) return old;
          const idx = sourceCol.leads.findIndex(
            (l) => l.id === payload.lead_id
          );
          const [movedLead] = sourceCol.leads.splice(idx, 1);
          movedLead.pivot.updated_at = new Date().toISOString();
          const destCol = newStatus.find((col) => col.id === payload.status_id);
          if (destCol) {
            destCol.leads.push(movedLead);
          }
          return { ...old, status: newStatus };
        });
      },
      onError: () => {
        toast.error("Erro ao mover lead!");
      },
    }
  );

  const onDragEnd = async (result) => {
    const { source, destination, draggableId } = result;

    if (!destination) return;

    if (
      source.droppableId === destination.droppableId &&
      source.index === destination.index
    ) {
      return;
    }

    if (source.droppableId === destination.droppableId) {
      return;
    }
    const notification = toast.loading("Movendo lead...");

    const previousFunnel = JSON.parse(JSON.stringify(funnel));
    prevFunnelRef.current = JSON.parse(JSON.stringify(funnel));

    const sourceColumn = funnel.status.find(
      (col) => String(col.id) === source.droppableId
    );
    const destColumn = funnel.status.find(
      (col) => String(col.id) === destination.droppableId
    );

    const [movedLead] = sourceColumn.leads.splice(source.index, 1);
    movedLead.pivot.updated_at = new Date().toISOString();
    destColumn.leads.splice(destination.index, 0, movedLead);

    const statusDestination = funnel.status.find(
      (col) => String(col.id) === destination.droppableId
    );

    // console.log(statusDestination);
    // console.log(movedLead);
    if (statusDestination?.register && !movedLead?.user_id) {
      setVisibleComplete(true);
      setBaseData(movedLead);
      setMovePayload({
        lead_id: movedLead.id,
        funnel_id: funnel.id,
        status_id: Number(destination.droppableId),
      });
      toast.update(notification, {
        render: "Complete o cadastro do Lead para movê-lo!",
        type: toast.TYPE.WARNING,
        isLoading: false,
        autoClose: 2000,
      });
      return;
    }

    if (statusDestination?.reservation && !movedLead?.user_id) {
      setVisibleComplete(true);
      setBaseData(movedLead);
      setMovePayload({
        lead_id: movedLead.id,
        funnel_id: funnel.id,
        status_id: Number(destination.droppableId),
      });
      toast.update(notification, {
        render: "Complete o cadastro do Lead para movê-lo!",
        type: toast.TYPE.WARNING,
        isLoading: false,
        autoClose: 2000,
      });
      return;
    }

    if (statusDestination?.reservation && movedLead?.sale.length === 0) {
      setVisibleBooking(true);
      setBaseData(movedLead);
      setMovePayload({
        lead_id: movedLead.id,
        funnel_id: funnel.id,
        status_id: Number(destination.droppableId),
      });
      if (movedLead?.simulation_sale?.length > 0) {
        toast.update(notification, {
          render: "O lead possui uma simulação, faça uma reserva!",
          type: toast.TYPE.WARNING,
          isLoading: false,
          autoClose: 2000,
        });
      } else {
        toast.update(notification, {
          render: "Faça a reserva do lote para mover o lead!",
          type: toast.TYPE.WARNING,
          isLoading: false,
          autoClose: 2000,
        });
      }
      return;
    }

    setFunnel({
      ...funnel,
      status: funnel.status.map((col) => {
        if (String(col.id) === source.droppableId) return sourceColumn;
        if (String(col.id) === destination.droppableId) return destColumn;
        return col;
      }),
    });

    const payload = {
      lead_id: movedLead.id,
      funnel_id: funnel.id,
      status_id: Number(destination.droppableId),
    };

    // console.log("Payload para o backend:", payload);

    try {
      await moveLeadAsync(payload);
      toast.update(notification, {
        render: "Lead movido com sucesso!",
        type: toast.TYPE.SUCCESS,
        isLoading: false,
        autoClose: 2000,
      });
    } catch (error) {
      setFunnel(previousFunnel);
      toast.update(notification, {
        render: "Erro ao mover lead!",
        type: toast.TYPE.ERROR,
        isLoading: false,
        autoClose: 2000,
      });
    }
  };

  const handleFilter = (data) => {
    const enterpriseValue = data.enterprise;
    const brokerValue = data.broker_id;
    setSelectedEnterprise(enterpriseValue || null);
    setSelectedBroker(brokerValue || null);
    setVisibleFilters(false);
  };

  const handleClearFilter = () => {
    setSelectedEnterprise(null);
    setSelectedBroker(null);
    setTeamsOptions([]);
    setBrokersOptions([]);
    form.resetField("enterprise");
    form.resetField("team_id");
    form.resetField("broker_id");
    setFunnel(funnel);
    setVisibleFilters(false);
  };

  const handleClearEnterpriseFilter = () => {
    setSelectedEnterprise(null);
    setSelectedBroker(null);
    setTeamsOptions([]);
    setBrokersOptions([]);
    form.resetField("enterprise");
    form.resetField("team_id");
    form.resetField("broker_id");
  };

  const handleClearBrokerFilter = () => {
    setSelectedBroker(null);
    form.resetField("broker_id");
  };

  const handleSearchClient = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);
  };

  const handleChangeFunnel = (value) => {
    setIdFunnel(value);
    setTimeout(() => {
      refetchKanban();
    }, 1000);
  };

  const selectEnterprise = async (enterprise_id) => {
    setIsLoadingTeams(true);
    setBrokersOptions([]);
    setSelectedBroker(null);
    form.resetField("broker_id");

    try {
      const response = await getTeamList(enterprise_id);
      const options = response.map((o) => ({
        value: o.id,
        label: o.name,
      }));
      setTeamsOptions(options);
      setIsLoadingTeams(false);
    } catch (error) {
      console.error("Error fetching team list:", error);
      setIsLoadingTeams(false);
    }
  };

  const selectTeam = async (team_id) => {
    setIsLoadingBrokers(true);

    try {
      const data = await getTeam(team_id);
      const corretoresFiltered = data.members.filter((member) =>
        member.registration_types.some(
          (registration) => registration.name === "Corretor"
        )
      );

      if (corretoresFiltered) {
        const brokerOptions = corretoresFiltered.map((i) => ({
          value: i.id,
          label: i.name,
        }));
        setBrokersOptions(brokerOptions);
      }
      setIsLoadingBrokers(false);
    } catch (error) {
      console.error("Error fetching brokers:", error);
      setIsLoadingBrokers(false);
    }
  };

  const filterFunnel = (statusList, search, enterprise, broker) => {
    if (!Array.isArray(statusList)) return [];

    return statusList.map((col) => {
      const leads = Array.isArray(col.leads) ? col.leads : [];

      let filteredLeads = leads;

      if (search) {
        const normalizedSearch = search.toLowerCase();
        filteredLeads = filteredLeads.filter((lead) =>
          lead?.name?.toLowerCase?.().includes(normalizedSearch)
        );
      }

      if (enterprise) {
        filteredLeads = filteredLeads.filter(
          (lead) => lead?.enterprise_id === enterprise
        );
      }

      if (broker) {
        filteredLeads = filteredLeads.filter(
          (lead) => lead?.broker_id === broker
        );
      }

      return {
        ...col,
        leads: filteredLeads,
      };
    });
  };

  const getBadgeClass = (column, lead) => {
    if (!lead?.pivot.updated_at || !column?.interval || !column?.interval_count)
      return "text-secondary";

    const now = new Date();
    const updatedAt = new Date(lead.pivot.updated_at);
    const expDate = new Date(updatedAt);

    if (column.interval === "day") {
      expDate.setDate(expDate.getDate() + column.interval_count);

      const nowDate = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate()
      );
      const expDateOnly = new Date(
        expDate.getFullYear(),
        expDate.getMonth(),
        expDate.getDate()
      );
      const diffTime = expDateOnly - nowDate;
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays < 0) {
        return "text-danger";
      } else if (diffDays === 0) {
        return "text-warning";
      } else {
        return "text-success";
      }
    }

    if (column.interval === "hour") {
      expDate.setHours(expDate.getHours() + column.interval_count);

      const diffMs = expDate - now;
      const diffHours = Math.floor(diffMs / (1000 * 60 * 60));

      if (diffHours < 0) {
        return "text-danger";
      } else if (diffHours === 0) {
        return "text-warning";
      } else {
        return "text-success";
      }
    }

    return "text-secondary";
  };

  const getBadgeText = (column, lead) => {
    if (!lead?.pivot.updated_at || !column?.interval || !column?.interval_count)
      return "";

    const now = new Date();
    const updatedAt = new Date(lead.pivot.updated_at);
    const expDate = new Date(updatedAt);

    if (column.interval === "day") {
      expDate.setDate(expDate.getDate() + column.interval_count);

      const nowDate = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate()
      );
      const expDateOnly = new Date(
        expDate.getFullYear(),
        expDate.getMonth(),
        expDate.getDate()
      );

      const diffTime = expDateOnly - nowDate;
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays === 0) {
        return "hoje";
      } else if (diffDays > 0) {
        return `em ${diffDays} dia${diffDays > 1 ? "s" : ""}`;
      } else {
        return `${Math.abs(diffDays)} dia${Math.abs(diffDays) > 1 ? "s" : ""}`;
      }
    }

    if (column.interval === "hour") {
      expDate.setHours(expDate.getHours() + column.interval_count);

      const diffMs = expDate - now;
      const diffHours = Math.floor(diffMs / (1000 * 60 * 60));

      if (diffHours === 0) {
        return "nesta hora";
      } else if (diffHours > 0) {
        return `em ${diffHours} hora${diffHours > 1 ? "s" : ""}`;
      } else {
        return `${Math.abs(diffHours)} hora${
          Math.abs(diffHours) > 1 ? "s" : ""
        }`;
      }
    }

    return "";
  };

  const onHideRegister = () => {
    if (prevFunnelRef.current) {
      setFunnel(prevFunnelRef.current);
      prevFunnelRef.current = null;
    }
    setVisibleComplete(false);
  };

  const onHideBooking = () => {
    if (prevFunnelRef.current) {
      setFunnel(prevFunnelRef.current);
      prevFunnelRef.current = null;
    }
    setVisibleBooking(false);
  };

  const handleDelete = (lead) => {
    confirmDialog({
      message: `Tem certeza que deseja excluir o lead "${lead.name}"? Esta ação não pode ser desfeita.`,
      header: "Confirmar Exclusão",
      icon: "fa-solid fa-triangle-exclamation",
      acceptLabel: "Sim",
      rejectLabel: "Cancelar",
      acceptClassName: "p-button-danger ms-2",
      rejectClassName: "p-button-outlined me-2",
      accept: () => {
        deleteLeadById(lead.id);
      },
      reject: () => {
        toast.info("Exclusão cancelada.");
      },
    });
  };

  const deleteLeadById = async (leadId) => {
    setDeletingLeadId(leadId);
    const toastId = toast.loading("Excluindo lead...");

    try {
      await deleteLead(leadId);

      // Atualizar o funil removendo o lead da coluna correspondente
      setFunnel((prevFunnel) => {
        const updatedStatus = prevFunnel.status.map((column) => ({
          ...column,
          leads: column.leads.filter((lead) => lead.id !== leadId),
        }));
        return { ...prevFunnel, status: updatedStatus };
      });

      // Refetch dos dados para garantir consistência
      refetchKanban();

      toast.update(toastId, {
        render: "Lead excluído com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
    } catch (error) {
      console.error("Erro ao excluir lead:", error);
      toast.update(toastId, {
        render: "Erro ao excluir lead. Tente novamente.",
        type: "error",
        isLoading: false,
        autoClose: 4000,
      });
    } finally {
      setDeletingLeadId(null);
    }
  };

  useEffect(() => {
    if (funnels?.funnels) {
      const options = funnels.funnels.map((funnel) => ({
        label: funnel.name,
        value: funnel.id,
      }));
      setFunnelsOptions([...options]);
    }
  }, [funnels]);

  useEffect(() => {
    if (!kanban) return;

    const updatedKanban = { ...kanban };
    updatedKanban.status.sort((a, b) => a.pivot.position - b.pivot.position);

    const filteredStatus = filterFunnel(
      updatedKanban.status,
      searchText,
      selectedEnterprise,
      selectedBroker
    );

    const sortedStatus = filteredStatus.map((col) => ({
      ...col,
      leads: [...col.leads].sort((a, b) => {
        const da = new Date(a.pivot.updated_at).getTime();
        const db = new Date(b.pivot.updated_at).getTime();
        return da - db;
      }),
    }));

    setFunnel({ ...updatedKanban, status: sortedStatus });
  }, [kanban, searchText, selectedEnterprise, selectedBroker, editedId]);

  return (
    <>
      <div className="row justify-content-between mb-3">
        <div className="col-md-6">
          <BreadCrumb model={items} home={home} className="breadCrumb" />
        </div>
        <div className="col-md-3 d-flex justify-content-end align-items-center">
          {permissions?.includes("253") && (
            <Button
              rounded
              label="Adicionar Lead"
              icon="pi pi-plus"
              onClick={() => setVisible(true)}
            />
          )}
        </div>
      </div>

      <div className="row justify-content-between mb-3">
        <div className="col-md-3">
          {permissions?.includes("230") && (
            <Select
              name="funnel"
              label={`Funil de vendas`}
              errors={form.formState.errors}
              control={form.control}
              options={funnelsOptions}
              onChange={(e) => {
                handleChangeFunnel(e);
              }}
            />
          )}
        </div>
        <div className="col-md-5 gap-3 text-end d-flex align-items-center justify-content-end my-3">
          <IconField iconPosition="left" className="w-50">
            <InputIcon className="pi pi-search"> </InputIcon>
            <InputText
              placeholder="Buscar Cliente"
              className="w-100"
              onChange={handleSearchClient}
            />
          </IconField>
          {selectedEnterprise || selectedBroker ? (
            <div className="d-flex gap-2 align-items-center">
              {selectedEnterprise && (
                <Chip
                  label={
                    enterprise.find((e) => e.value === selectedEnterprise)
                      ?.label
                  }
                  className="cursor-pointer"
                  removable
                  onRemove={handleClearEnterpriseFilter}
                />
              )}
              {selectedBroker && (
                <Chip
                  label={
                    brokersOptions.find((b) => b.value === selectedBroker)
                      ?.label
                  }
                  className="cursor-pointer"
                  removable
                  onRemove={handleClearBrokerFilter}
                />
              )}
              <Button
                text
                severity="secondary"
                label="Limpar tudo"
                icon="pi pi-times"
                onClick={handleClearFilter}
                className="p-button-sm"
              />
            </div>
          ) : (
            <Button
              outlined
              severity="secondary"
              label="Outros Filtros"
              icon="pi pi-filter"
              className="w-50"
              onClick={() => setVisibleFilters(true)}
              style={{ height: "44.8px" }}
            />
          )}
        </div>
      </div>

      {isLoadingFunnels || isLoadingKanban ? (
        <Skeleton width="100%" height={400} className="mt-3" />
      ) : (
        <Panel title="Funil de Vendas" mainCss="w-100 mt-3">
          <DragDropContext onDragEnd={onDragEnd}>
            <div
              style={{ display: "flex", maxWidth: "100%", overflowX: "auto" }}
            >
              {funnel?.status?.map((column) => (
                <Droppable
                  key={column.id}
                  droppableId={String(column.id)}
                  isDropDisabled={!permissions?.includes("256")}
                >
                  {(provided) => (
                    <div
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      className="funnel-card"
                      style={{
                        padding: 12,
                        minWidth: 280,
                        borderRadius: "15px",
                        maxWidth: "300px",
                        margin: "0 8px",
                        maxHeight: "650px",
                        overflowY: "auto",
                      }}
                    >
                      <div className="row">
                        {column.schedule ? (
                          <>
                            <div className="col-sm-8">
                              <h5
                                className="ps-2 text-start"
                                style={{ fontSize: "16px" }}
                              >
                                {column.name}
                              </h5>
                            </div>
                            <div className="col-sm-4 gap-2 d-flex justify-content-end align-items-start">
                              <span
                                className="badge bg-secondary mt-1"
                                style={{ fontSize: "11px" }}
                              >
                                {column.items.length}
                              </span>
                              <Button
                                icon="pi pi-calendar"
                                className="p-button-rounded p-button-secondary"
                                onClick={() => {
                                  setSelectedColumn(
                                    funnel?.filter(
                                      (col) => col.id === column.id
                                    )[0]?.items
                                  );
                                  setVisibleCalendar(true);
                                }}
                                style={{ height: "24px", width: "24px" }}
                              />
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="col-10">
                              <h5
                                className="ps-2 text-start"
                                style={{ fontSize: "16px" }}
                              >
                                {column.name}
                              </h5>
                            </div>
                            <div className="col-2 d-flex align-items-start">
                              <span
                                className="badge bg-secondary"
                                style={{ fontSize: "11px" }}
                              >
                                {column.leads.length}
                              </span>
                            </div>
                          </>
                        )}
                      </div>
                      {column.leads.map((item, index) => (
                        <Draggable
                          key={item.id}
                          draggableId={String(item.id)}
                          index={index}
                        >
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              className="funnel-card-item"
                              style={{
                                userSelect: "none",
                                padding: 16,
                                margin: "0 0 8px 0",
                                minHeight: "50px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                ...provided.draggableProps.style,
                              }}
                            >
                              <div className="row">
                                <div className="col-md-10 d-flex align-items-center">
                                  <img
                                    src={item.profile_pic_url || defaultImage}
                                    alt="profile"
                                    className="rounded-circle me-2"
                                    style={{ width: "30px", height: "30px" }}
                                  />
                                  <div className="d-flex align-items-center flex-wrap">
                                    <h6
                                      className="text-start me-2 mb-0"
                                      style={{ fontSize: "14px" }}
                                    >
                                      {item.name}
                                    </h6>
                                    {item.unread_messages_count > 0 && (
                                      <span 
                                        className="badge bg-danger rounded-pill d-flex align-items-center unread-messages-badge"
                                        style={{ 
                                          fontSize: "10px", 
                                          padding: "4px 6px",
                                          minWidth: "18px",
                                          height: "18px",
                                          position: "relative"
                                        }}
                                        title={`${item.unread_messages_count} mensagem${item.unread_messages_count > 1 ? 's' : ''} não lida${item.unread_messages_count > 1 ? 's' : ''}`}
                                      >
                                        <i className="fa-brands fa-whatsapp me-1" style={{ fontSize: "8px" }}></i>
                                        {item.unread_messages_count > 99 ? '99+' : item.unread_messages_count}
                                      </span>
                                    )}
                                  </div>
                                </div>
                                <div className="col-md-2 d-flex justify-content-end align-items-center">
                                  {permissions?.includes("255") && (
                                    <div className="dropdown">
                                      <i
                                        className={`fa ${
                                          deletingLeadId === item.id
                                            ? "fa-spinner fa-spin"
                                            : "fa-ellipsis-v"
                                        }`}
                                        id={`dropdownMenuButton-${item.id}`}
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        style={{
                                          cursor:
                                            deletingLeadId === item.id
                                              ? "not-allowed"
                                              : "pointer",
                                          width: "24px",
                                          height: "24px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          pointerEvents: "auto",
                                          opacity:
                                            deletingLeadId === item.id
                                              ? 0.6
                                              : 1,
                                        }}
                                      ></i>
                                      <ul
                                        className="dropdown-menu"
                                        aria-labelledby={`dropdownMenuButton-${item.id}`}
                                        style={{ pointerEvents: "auto" }}
                                      >
                                        <li>
                                          <button
                                            className="dropdown-item"
                                            onClick={() => {
                                              setDefaultActiveIndex(0);
                                              setVisibleLead(true);
                                              setLeadId(item.id);
                                            }}
                                            disabled={
                                              deletingLeadId === item.id
                                            }
                                          >
                                            <i className="fa fa-eye me-2"></i>
                                            Ver/Editar
                                          </button>
                                        </li>
                                        <li>
                                          <button
                                            className="dropdown-item"
                                            onClick={() => {
                                              setDefaultActiveIndex(2);
                                              setVisibleLead(true);
                                              setLeadId(item.id);
                                            }}
                                            disabled={
                                              deletingLeadId === item.id
                                            }
                                            >
                                            <i className="fa fa-comments me-2"></i>
                                            Tratativa de Lead
                                            </button>
                                          </li>
                                          {permissions?.includes("273") && (
                                            <li>
                                            <button
                                              className="dropdown-item text-danger"
                                              onClick={() => handleDelete(item)}
                                              disabled={
                                              deletingLeadId === item.id
                                              }
                                            >
                                              <i className="fa fa-trash me-2"></i>
                                              {deletingLeadId === item.id
                                              ? "Excluindo..."
                                              : "Excluir"}
                                            </button>
                                            </li>
                                          )}
                                          </ul>
                                        </div>
                                        )}
                                      </div>
                                      </div>
                                      <div className="row mt-3">
                                      <div className="col-md-12 d-flex align-items-center">
                                        <h6
                                        style={{ fontSize: "13px" }}
                                        className="text-start"
                                        title={item.email} // Mostra o email completo no hover
                                  >
                                    <i className="fa fa-envelope me-2"></i>
                                    {truncateEmail(item.email)}
                                  </h6>
                                </div>
                                <div className="col-md-12 d-flex align-items-center">
                                  <h6
                                    className={item.unread_messages_count > 0 ? "whatsapp-with-unread" : ""}
                                    style={{
                                      fontSize: "13px",
                                      cursor: "pointer",
                                      fontWeight: "600" // Sempre negrito
                                    }}
                                    onClick={() => {
                                      setSelectedLead({
                                        id: item.id,
                                        name: item.name,
                                        phone: item.phone,
                                        email: item.email,
                                        profile_pic_url: item.profile_pic_url

                                      });
                                      setVisibleWhatsApp(true);
                                    }}
                                    title={item.unread_messages_count > 0 ? 
                                      `Clique para ver ${item.unread_messages_count} mensagem${item.unread_messages_count > 1 ? 's' : ''} não lida${item.unread_messages_count > 1 ? 's' : ''}` : 
                                      "Abrir WhatsApp"
                                    }
                                  >
                                    <i 
                                      className="fa-brands fa-whatsapp me-2"
                                    ></i>
                                    {item.phone}
                                  </h6>
                                </div>
                                <div className="col-md-12 d-flex align-items-center">
                                  <h6 style={{ fontSize: "13px" }}>
                                    <i className="fa-solid fa-map-location-dot me-2"></i>
                                    {item.address?.address ?? ""}
                                  </h6>
                                </div>
                              </div>
                              <div className="row mt-3">
                                <div className="col-md-6 d-flex align-items-center">
                                  <span
                                    className={`badge py-1 ${getBadgeClass(
                                      column,
                                      item
                                    )}`}
                                    style={{ fontSize: "11px" }}
                                  >
                                    {getBadgeText(column, item)}
                                  </span>
                                </div>
                                <div className="col-md-6 text-end">
                                  <Tooltip
                                    target={`.broker-photo-${item.id}`}
                                    content={item.broker?.name ?? "corretor"}
                                    position="top"
                                  />
                                  <img
                                    src={
                                      item.broker?.profile_photo?.path ??
                                      defaultImage
                                    }
                                    alt="profile"
                                    className={`rounded-circle me-2 broker-photo-${item.id}`}
                                    style={{ width: "30px", height: "30px" }}
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              ))}
            </div>
          </DragDropContext>
        </Panel>
      )}

      <Modal
        dynamicTitle={"Filtros"}
        position={"top-right"}
        visible={visibleFilters}
        setVisible={setVisibleFilters}
        onHide={() => setVisibleFilters(false)}
        dynamicWidth={window.innerWidth <= 992 ? "80vw" : "25vw"}
      >
        <form onSubmit={form.handleSubmit(handleFilter)}>
          <Select
            name="enterprise"
            label={`Empreendimento`}
            isLoading={isLoadingEnterprises}
            errors={form.formState.errors}
            control={form.control}
            options={enterprise}
            onChange={(e) => selectEnterprise(e)}
          />
          <div className="mt-3">
            <Select
              name="team_id"
              label={isLoadingTeams ? "Carregando..." : `Time`}
              control={form.control}
              errors={form.formState.errors}
              onChange={(e) => selectTeam(e)}
              disabled={isLoadingTeams || !teamsOptions.length}
              options={teamsOptions}
            />
          </div>
          <div className="mt-3">
            <Select
              name="broker_id"
              label={isLoadingBrokers ? "Carregando..." : `Corretor`}
              errors={form.formState.errors}
              disabled={isLoadingBrokers || !brokersOptions.length}
              control={form.control}
              options={brokersOptions}
            />
          </div>
          <div className="row justify-content-between mt-3">
            <div className="col-md-6">
              <Button
                label="Limpar"
                severity="secondary"
                type="button"
                icon="pi pi-times"
                onClick={handleClearFilter}
              />
            </div>
            <div className="col-md-6 text-end">
              <Button type="submit" label="Filtrar" icon="pi pi-filter" />
            </div>
          </div>
        </form>
      </Modal>
      {visible && (
        <ModalAddLead
          visible={visible}
          baseData={baseData}
          setBaseData={setBaseData}
          setEditedId={setEditedId}
          setVisible={setVisible}
          funnelId={funnel?.id}
        />
      )}
      <ModalWhatsApp
        visible={visibleWhatsApp}
        setVisible={setVisibleWhatsApp}
        leadId={selectedLead?.id}
        leadName={selectedLead?.name}
        leadPhone={selectedLead?.phone}
        leadProfilePic={selectedLead?.profile_pic_url}
      />
      <ModalCalendarSchedules
        visible={visibleCalendar}
        setVisible={setVisibleCalendar}
        schedules={selectedColumn}
      />
      {visibleLead && (
        <ModalLeadDetails
          visible={visibleLead}
          setVisible={setVisibleLead}
          leadId={leadId}
          defaultActiveIndex={defaultActiveIndex}
          idFunnel={idFunnel}
        />
      )}
      <ModalCompleteRegister
        baseData={baseData}
        leadId={baseData?.id}
        onHide={onHideRegister}
        refetchLeads={refetchKanban}
        patchLeadStatus={moveLeadAsync}
        visible={visibleComplete}
        movePayload={movePayload}
        setVisible={setVisibleComplete}
      />
      <ModalBooking
        visible={visibleBooking}
        onHide={onHideBooking}
        refetchLeads={refetchKanban}
        setVisible={setVisibleBooking}
        baseData={baseData}
        movePayload={movePayload}
      />
    </>
  );
};

export default Funnel;
